import React, { Component } from "react";
import "../App.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faSearch,
    faPlus,
    faChevronDown,
    faLocationArrow,
    faBars,
} from "@fortawesome/free-solid-svg-icons";
import "../component/modal.css";
import Icon from "./facebook-brands.svg";
import Google from "./google-brands.svg";
import firebase from "../config/firebase";

class Header extends Component {
    constructor() {
        super();
        this.state = {
            user: {},
        };
    }

    render() {
        let login_page = () => {
            console.log("run");
            let modal = document.querySelector("#myModal");
            modal.style.display = "block";
        };
        let myFunction = () => {};
        let closeX = () => {
            var modal = document.getElementById("myModal");
            modal.style.display = "none";
        };
        let Facebook_login = () => {
            console.log("working");
            var provider = new firebase.auth.FacebookAuthProvider();
            firebase
                .auth()
                .signInWithPopup(provider)
                .then(function (result) {
                    // var token = result.credential.accessToken;
                    var user = result.user;
                    console.log("user>>.", user);

                    let create_user = {
                        name: user.displayName,
                        email: user.email,
                        profile: user.photoURL,
                        uid: user.uid,
                    };
                    console.log("display", user.displayName);
                    console.log("create", create_user.name);

                    firebase
                        .database()
                        .ref("/")
                        .child(`users/${user.uid}`)
                        .set(create_user);
                })

                .catch(function (error) {
                    var errorCode = error.code;
                    var errorMessage = error.message;
                    console.log(errorMessage);
                });
        };

        return (
            <header>
                <div className="headeritems">
                    <span className="navigate" onClick={myFunction}>
                        <FontAwesomeIcon className="hamburger" icon={faBars} />
                    </span>
                    <div className="logo">
                        <img
                            src="https://upload.wikimedia.org/wikipedia/commons/thumb/9/91/Logotyp_OLX_.png/1200px-Logotyp_OLX_.png"
                            alt=""
                        />
                    </div>
                </div>
                <div className="location-box">
                    <div className="icon">
                        <FontAwesomeIcon icon={faSearch} />
                    </div>
                    <input
                        type="text"
                        name=""
                        id=""
                        placeholder="Your Location"
                        value="Pakistan"
                    />
                    <button>
                        {" "}
                        <FontAwesomeIcon icon={faChevronDown} />{" "}
                    </button>
                </div>
                <div className="search-box">
                    <input
                        type="text"
                        placeholder="Find Cars, Mobile Phones and more..."
                    />
                    <button>
                        <FontAwesomeIcon className={"icon"} icon={faSearch} />
                    </button>
                </div>
                <div className="header-btns">
                    <div className="header-login">
                        <u onClick={login_page}>Login</u>
                        <button className="header-btn">
                            <FontAwesomeIcon className={"icon"} icon={faPlus} />
                            SELL
                        </button>
                    </div>
                </div>
                <div className="current headeritems">
                    {" "}
                    <p>Pakistan </p>
                    <FontAwesomeIcon
                        className={"icon"}
                        icon={faLocationArrow}
                    />
                </div>
                <center>
                    <div id="myModal" className="modal">
                        {/* Modal content */}
                        <div className="modal-content">
                            <div className="Main-login">
                                <div
                                    onClick={closeX}
                                    id="close"
                                    className="close"
                                >
                                    <span>✖</span>
                                </div>
                                <div className="main-img">
                                    <img
                                        src="https://statics.olx.com.pk/external/base/img/loginEntryPointPost.webp"
                                        alt=""
                                    />
                                    <br />
                                    <br />
                                    <p>
                                        Help make OLX safer place to buy and
                                        sell
                                    </p>
                                    <br />
                                    <br />
                                </div>
                                <div className="login-btns">
                                    <button>Continue with phone</button>
                                    <button onClick={Facebook_login}>
                                        <img
                                            className="icons"
                                            width="20px"
                                            src={Icon}
                                            alt=""
                                        />
                                        Continue with facebook
                                    </button>
                                    <button>
                                        <img
                                            className="icons"
                                            width="20px"
                                            src={Google}
                                            alt=""
                                        />{" "}
                                        Continue with google
                                    </button>
                                    <button>Continue with email</button>
                                </div>
                                <br />
                                <p className="para">
                                    We won't share your personal details with
                                    anyone
                                </p>
                                <p className="light">
                                    If you continue, you are accepting
                                    <span>
                                        OLX Terms and Conditions and Privacy
                                        Policy
                                    </span>
                                </p>
                            </div>
                        </div>
                    </div>
                </center>
            </header>
        );
    }
}
export default Header;
